import script from "./RegistrationView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationView.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationView.vue?vue&type=style&index=0&id=185a60f8&lang=scss&scoped=true"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-185a60f8"]])

export default __exports__